module.exports = __webpack_public_path__ + "img/Qrespi-icon.7a9bbe0a.svg";